import PredictiveSearch from '@shopify/theme-predictive-search';
import { debounce } from '../../utils/debounce';

export default function () {
  // ###### SEARCH ######
  const predictiveSearch = new PredictiveSearch({
    resources: {
      type: ['product', 'collection'],
      limit: 3,
      options: {
        unavailable_products: 'last',
        fields: [
          PredictiveSearch.FIELDS.TITLE,
          // PredictiveSearch.FIELDS.VENDOR,
          PredictiveSearch.FIELDS.PRODUCT_TYPE,
          //PredictiveSearch.FIELDS.VARIANTS_TITLE,
        ],
      },
    },
  });

  // on input change search module
  let activeSearchModule;
  let searchQuery;
  const searchResultTemplate = document.querySelector('#search-result-template').innerHTML;
  const searchResultCollectionTemplate = document.querySelector(
    '#search-result-template-collection',
  ).innerHTML;

  const onChange = (e) => {
    searchQuery = e.target.value;

    const searchModuleDropdown = activeSearchModule.querySelector('.search-module__dropdown');
    const searchModuleContent = activeSearchModule.querySelector('.search-module__content');
    const noResultsEl = activeSearchModule.querySelector('.search-module__no-results');
    const searchOverlay = document.querySelector('.search-body-overlay');
    const loader = document.querySelector('.search-loader');
    searchOverlay.addEventListener('click', () => {
      searchModuleDropdown.classList.add('hide');
      searchOverlay.classList.add('hide');
    });

    if (searchQuery === '') {
      //const searchModuleActions = activeSearchModule.querySelector('.search-results__actions');
      searchModuleDropdown.classList.add('hide');
      searchOverlay.classList.add('hide');
    } else {
      searchOverlay.classList.remove('hide');
      loader.classList.remove('hide');
    }

    predictiveSearch.query(searchQuery);
  };
  const debouncedSearch = debounce(onChange, 500);
  const searchModulesInputElements = [...document.querySelectorAll('.search-module__search-input')];
  let typingTimer;
  let doneTypingInterval = 500;
  searchModulesInputElements.forEach((searchInput) => {
    searchInput.addEventListener('keyup', (e) => {
      clearTimeout(typingTimer);
      //searchModulesInputElements.classList.add('search-module__search-input--active');
      typingTimer = setTimeout(() => {
        const targetModule = document.querySelector(e.target.getAttribute('data-module-id'));
        activeSearchModule = targetModule;
        debouncedSearch(e);
      }, doneTypingInterval);
    });
  });

  const buildResults = (json, productCount, collectionCount, totalCount) => {
    //console.log(json);
    const searchResultsProducts = activeSearchModule.querySelector('#search-results-products');
    const searchResultsCollection = activeSearchModule.querySelector('#search-results-collections');
    let current_locale = document.querySelector('html').getAttribute('lang');
    const loader = document.querySelector('.search-loader');
    loader.classList.remove('hide');

    let searchResultsStringProducts = '';
    let searchResultsStringCollections = '';
    let totalResults = 0;
    let totalResultsIndex = 0;
    let totalProductResults = 0;
    let totalCollectionsResults = 0;

    if (json.resources.results.products) {
      totalProductResults = json.resources.results.products.length;
      totalResults = parseInt(totalResults + totalProductResults);
    }
    if (json.resources.results.collections) {
      totalCollectionsResults = json.resources.results.collections.length;
      totalResults = parseInt(totalResults + totalCollectionsResults);
    }

    if (totalProductResults === 0) {
      searchResultsProducts.innerHTML = '';
    }

    if (totalCollectionsResults === 0) {
      searchResultsCollection.innerHTML = '';
    }
    json.resources.results.products.forEach((product, index) => {
      //console.log(init_product);

      const cleaned_product_url = product.url.split('?')[0];
      let req_url = '';
      if (current_locale === 'en') {
        req_url = `${cleaned_product_url}?view=json`;
      } else {
        req_url = `/${current_locale}${cleaned_product_url}?view=json`;
      }

      let translatedProduct = product;
      
      let translatedProductRequest = new XMLHttpRequest();
      translatedProductRequest.open('GET', req_url, false);

      translatedProductRequest.onload = () => {
        if (translatedProductRequest.status >= 200 && translatedProductRequest.status < 400) {
          // Success!
          let data = JSON.parse(translatedProductRequest.responseText);
          translatedProduct = data.product;
        } else {
          translatedProduct = product;
        }
      };

      translatedProductRequest.onerror = function (err) {
        console.log('onerror', err);
        translatedProduct = product;
      };

      setTimeout(() => {
        translatedProductRequest.send();

        var product_price = translatedProduct.price.replace(',', '.');
        var shown_product_price;
        var productVat = 1;
        if (productVat != 1) {
          shown_product_price = translatedProduct.price;
        }
        var product_price_with_vat =
          Math.round((product_price * productVat + Number.EPSILON) * 100) / 100;
        var product_price_with_vat_string = product_price_with_vat + '';
        shown_product_price = product_price_with_vat_string;

        if (index < totalProductResults) {
          let searchResult = searchResultTemplate;
          var symbol = '€';

          searchResult = searchResult.replace('__title__', translatedProduct.title);
          searchResult = searchResult.replace(
            '__price__',
            `${symbol} ${shown_product_price.replace('.', ',')}`,
          );
          searchResult = searchResult.replace('__image__', translatedProduct.image);
          searchResult = searchResult.replace(/__product\.id__/g, translatedProduct.id);
          searchResult = searchResult.replace(
            /__product\.available__/g,
            translatedProduct.available,
          );
          searchResult = searchResult.replace('__product.url__', translatedProduct.url);
          searchResultsStringProducts += searchResult;
        } else {
          loader.classList.add('hide');
        }

        if (index == totalProductResults - 1) {
          loader.classList.add('hide');
          searchResultsProducts.innerHTML = searchResultsStringProducts;
        }
      }, totalResultsIndex * 250);

      totalResultsIndex++;
    });
console.log(json);
    json.resources.results.collections.forEach((collection, index) => {
      const cleaned_collection_url = collection.url.split('?')[0];
    
      let req_url = '';
      if (current_locale === 'en') {
        req_url = `${cleaned_collection_url}?view=json`;
      } else {
        req_url = `/${current_locale}${cleaned_collection_url}?view=json`;
      }

      let translatedCollection = collection;
      let translatedCollectionRequest = new XMLHttpRequest();
      translatedCollectionRequest.open('GET', req_url, true);

      translatedCollectionRequest.onload = () => {
        if (translatedCollectionRequest.status >= 200 && translatedCollectionRequest.status < 400) {
          // Success!
          console.log(translatedCollectionRequest);
          let data = JSON.parse(translatedCollectionRequest.responseText);
          translatedCollection = data.collection;
        } else {
          translatedCollection = collection;
        }
      };

      translatedCollectionRequest.onerror = function (err) {
        console.log('onerror', err);
        translatedCollection = collection;
      };

      setTimeout(() => {
        translatedCollectionRequest.send();

        if (index < totalCollectionsResults) {
          let searchResult = searchResultCollectionTemplate;

          searchResult = searchResult.replace('__title__', translatedCollection.title);
          searchResult = searchResult.replace('__image__', translatedCollection.featured_image.url);
          searchResult = searchResult.replace(/__collection\.id__/g, translatedCollection.id);
          searchResult = searchResult.replace('__collection.url__', translatedCollection.url);
          searchResultsStringCollections += searchResult;
        } else {
        }

        if (index == totalCollectionsResults - 1) {
          searchResultsCollection.innerHTML = searchResultsStringCollections;
          loader.classList.add('hide');
        }
      }, totalResultsIndex * 250);
    });
    totalResultsIndex++;
  };
  //loader.classList.add('hide');

  predictiveSearch.on('success', function (json) {
    //console.log(json);

    const searchModuleContent = activeSearchModule.querySelector('.search-module__content');
    const searchModuleDropdown = activeSearchModule.querySelector('.search-module__dropdown');
    const searchModuleProducts = activeSearchModule.querySelector(
      '.search-module__content--products',
    );

    const searchModuleCollections = activeSearchModule.querySelector(
      '.search-module__content--collections',
    );

    const noResultsEl = activeSearchModule.querySelector('.search-module__no-results');
    const searchModuleActionsProducts = activeSearchModule.querySelector(
      '.search-module__content--products .search-results__actions',
    );
    const searchModuleActionsCollections = activeSearchModule.querySelector(
      '.search-module__content--collections .search-results__actions',
    );
    const searchResults = activeSearchModule.querySelector('.search-results');
    const loader = document.querySelector('.search-loader');

    searchModuleDropdown.classList.remove('hide');

    if (json.resources.results.products.length || json.resources.results.collections.length) {
      noResultsEl.classList.add('hide');
      loader.classList.add('hide');
      buildResults(json);
    } else {
      noResultsEl.classList.remove('hide');
      loader.classList.add('hide');
    }

    if (json.resources.results.products.length) {
      searchModuleProducts.classList.remove('hide');
    } else {
      searchModuleProducts.classList.add('hide');
    }

    if (json.resources.results.collections.length) {
      searchModuleCollections.classList.remove('hide');
    } else {
      searchModuleCollections.classList.add('hide');
    }

    if (json.resources.results.products.length === 3) {
      searchModuleActionsProducts.classList.remove('hide');

      searchModuleActionsProducts
        .querySelector('.search-module__view-more')
        .setAttribute('href', `${window.searchURL}?q=${encodeURI(searchQuery)}*`);
    } else {
      searchModuleActionsProducts.classList.add('hide');
    }
  });

  predictiveSearch.on('error', function (error) {
    console.log(error);
  });
}
